export default {
  SET_FORM_DATA(state, payload) {
    state.formData = {
      ...state.formData,
      ...payload,
    }
  },
  SET_PAGE(state, payload) {
    state.page = payload
  },
  INCREMENT_REQUEST_VERSION(state) {
    state._requestVersion += 1
  },
  SET_ITEMS(state, { payload, version }) {
    if (version !== state._requestVersion) return
    state.items = [...state.items, ...payload.forms]
    state.total = payload.total
    state.statistics = {
      total: payload.total,
      total_all: payload.total_all,
      total_active: payload.total_active,
      total_expired: payload.total_expired,
      total_paid: payload.total_paid,
      total_payment_amount: payload.total_payment_amount,
      total_active_payment_amount: payload.total_active_payment_amount,
      total_expired_payment_amount: payload.total_expired_payment_amount,
      total_finished_invoices: payload.total_finished_invoices,
      total_partner_fee: payload.total_partner_fee,
      total_buyer_fee: payload.total_buyer_fee,
    }
  },
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_ACTION_LOADING(state, status) {
    state.actionLoading = status
  },
  SET_SEARCH(state, payload) {
    state.search = payload
  },
  UPDATE_ITEMS_AFTER_DELETE(state, id) {
    state.items = state.items.filter((item) => item.id !== id)
  },
  ADD_PAYMENT_LINK(state, payload) {
    state.items = [payload, ...state.items]
  },
  ADD_ITEM_AFTER_UPDATE(state, payload) {
    state.items.unshift(payload)
    state.total += 1
  },
  CHANGE_ITEM_AFTER_UPDATE(state, payload) {
    const index = state.items.findIndex((item) => item.id === payload.id)

    if (index !== -1) {
      state.items.splice(index, 1, payload)
    }
  },
  SET_ID(state, id) {
    state.id = id
  },
  SET_STATUS_AFTER_UPDATE(state, { status }) {
    state.formData.status = status
  },
  SET_SORTING(state, payload) {
    state.sort = payload
  },
  SET_CHRONOLOGY_SORT(state, payload) {
    state.chronologySort = payload
  },
  RESET_PAGE(state) {
    state.items = []
    state.page = 1
    state.total = null
  },
  RESET_SEARCH(state) {
    state.search = null
  },
  SET_DATE_RANGE(state, payload) {
    state.dateRange = payload
  },
  RESET_DATE_RANGE(state) {
    state.dateRange = null
  },
  SET_STATUSES(state, payload) {
    state.statuses = payload
  },
  RESET_STATUSES(state) {
    state.statuses = null
  },
  RESET_STORE(state) {
    state.id = null
    state.formData = null
    state.loading = false
    state.actionLoading = false

    state.items = []
    state.page = 1
    state.total = null
    state.statistics = null
    state.search = null
    state.dateRange = null
    state.statuses = null
    state._requestVersion = 0

    state.sort = {}
  },
  SET_CURRENT_PAYMENT_LINK(state, payload) {
    state.currentPaymentLink = payload
  },
  RESET_PAYMENT_LINK_DETAILS(state) {
    state.currentPaymentLink = null
  },
}
